import React from 'react';
import styled from 'styled-components';
import { FaGithub } from 'react-icons/fa';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1rem 0;
`;

const GitHubLink = styled.a`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 16px;
  padding: 8px 16px;
  border: none;
  background-size: 300% 100%;
  border-radius: 50px;
  font-family: "maitree", sans-serif;
  transition: all 0.4s ease-in-out;
  background-image: linear-gradient(
    to right,
    rgba(114, 114, 114, 0.5),
    rgba(106, 106, 107, 0.5),x
    rgba(98, 99, 101, 0.5),
    rgba(89, 92, 94, 0.5),
    rgba(80, 85, 87, 0.5),
    #505557,
    #4a4f51,
    #44494a,
    #3e4344,
    #393c3e,
    #353637,
    #303031,
    #2a2a2a
  );
  box-shadow: 0 4px 15px 0 rgb(242, 242, 242, 0.2);
  gap: 8px;

  &:hover {
    background-position: 100% 0;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

const GitHubButton = ({ url }) => {
  if (!url) return null;
  
  return (
    <ButtonContainer>
      <GitHubLink href={url} target="_blank" rel="noopener noreferrer">
        <FaGithub />
  
      </GitHubLink>
    </ButtonContainer>
  );
};

export default GitHubButton;
